import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagBookmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBagBookmark2"><Path d="M11.5 21.5H4L6 7.5H18L18.5714 11.5M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5M20.5 14.5H14.5V21.5L17.5 20L20.5 21.5V14.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBagBookmark2;
